import { jsxs } from "react/jsx-runtime";
import React from "react";
import { string, oneOfType, element } from "prop-types";
const propTypes = {
  /** Label text */
  label: oneOfType([string, element]).isRequired,
  /** Extra symbol or text for marking the required field */
  reqText: oneOfType([string, element]),
  /** Can be used to add classes to base HTML element. */
  className: string,
  /** Alternative for the 'for' attribute */
  htmlFor: string,
  /** Prefix all classes in every element with this string */
  prefix: string
};
const Label = (props) => {
  const {
    prefix = "",
    label = "Label",
    reqText,
    htmlFor,
    className,
    ...otherProps
  } = props;
  return /* @__PURE__ */ jsxs("label", { htmlFor, className, ...otherProps, children: [
    label,
    reqText && /* @__PURE__ */ jsxs("em", { className: `${prefix}required`, children: [
      " ",
      reqText
    ] })
  ] });
};
Label.propTypes = propTypes;
var Label_default = Label;
export {
  Label_default as default
};
